/**
 * Fixed Speak Easy question categories (old/category.php, old/admin/editor.php).
 * `id` is the value stored in the questions table's `category` column.
 */
export const SPEAK_EASY_CATEGORIES = ["Warm-up", "Explore", "Introspect"];

/**
 * Map loose spellings onto a known category, like old/admin/insertCSV.php's
 * normalizeCategory ("warm up", "warmpup", "warm-up" -> "Warm-up"). Returns "" if unknown.
 */
export function normalizeSpeakEasyCategory(raw) {
  const key = String(raw ?? "").trim().toLowerCase().replace(/[\s_]+/g, "-");
  if (key === "warmpup" || key === "warmup") return "Warm-up";
  return SPEAK_EASY_CATEGORIES.find((c) => c.toLowerCase() === key) || "";
}
